import { i18next } from '@/i18n'

export default {
  path: 'users/',
  meta: {
    title: i18next.t('routes.comptes'),
    auth: 'ROLE_USER'
  },
  component: () =>
    import(/* webpackChunkName: "users" */ '@/pages/users/Users.vue'),
  children: [
    {
      path: '',
      name: 'users',
      meta: {
        title: i18next.t('routes.myAccountsTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "users" */ '@/pages/users/UsersList.vue'
        )
    }
  ]
}
